import React, { PropTypes } from 'react';
import { Navbar } from 'react-bootstrap';
import { IndexLink, Link } from 'react-router';

class Purchase extends React.Component {
   render() {
      return (
         <div className="Purchase" >
            <Navbar >
               <Navbar.Header >
                  <Navbar.Brand >
                     <Link to="/purchase/" activeStyle={{ color: 'red' }} >Purchase</Link >
                  </Navbar.Brand >
               </Navbar.Header >
               <ul className="nav navbar-nav" >
                  <li >
                     <IndexLink to="/purchase/" activeStyle={{ color: 'red' }} >All</IndexLink >
                  </li >
                  <li >
                     <Link to="/purchase/newPurchase" activeStyle={{ color: 'red' }} >New</Link >
                  </li >
                  <li >
                     <Link to="/purchase/unAuthorized" activeStyle={{ color: 'red' }} >UnAuthorized</Link >
                  </li >
                  <li >
                     <Link to="/purchase/unpaidBill" activeStyle={{ color: 'red' }} >Unpaid Bills</Link >
                  </li >

               </ul >
            </Navbar >
            {this.props.children}
         </div >
      );
   }
}

Purchase.propTypes = {
   children: PropTypes.object
};

export default Purchase;



/** WEBPACK FOOTER **
 ** ./src/components/InvoiceManagement/Purchase/Purchase.js
 **/